import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import Priv from './priv';
import Standard from './standard';
import External from './external';
import Accesskeys from './access_keys';
import { useLocation } from 'react-router-dom';

import Auth from '../../../../data/auth-service';

const PrivilegedTab = 0;
const StandardTab = 1;
const ExternalTab = 2;
const AccessKeysTab = 3;

const AuthContainer = (props) => {
    const { state } = useLocation();
    const [tabValue, setTabValue] = useState(PrivilegedTab);
    const privilegedAuthPerms = Auth.permissions.get('AuthenticationPrivileged');
    const standardAuthPerm = Auth.permissions.get('AuthenticationStandard');
    const externalAuthPerms = Auth.permissions.get('AuthenticationExternal');
    const accessKeysAuthPerms = Auth.permissions.get('AccessKeys');

    const handleTabChange = (e, tab) => {
        setTabValue(tab);
    };

    useEffect(() => {
        if (state && state.tab) {
            setTabValue(state.tab);
        }
    }, [state]);

    return (
        <Grid container>
            <Grid item xs={12}>
                <Box mb={2}>
                    <AppBar position="static">
                        <Tabs value={tabValue} onChange={handleTabChange}>
                            {privilegedAuthPerms.read && <Tab aria-label="privileged tab" label="Privileged" />}
                            {standardAuthPerm.read && <Tab aria-label="standard tab" label="Standard" />}
                            {externalAuthPerms.read && <Tab aria-label="external tab" label="External" />}
                            {accessKeysAuthPerms.write && <Tab aria-label="Access Keys tab" label="Access Keys" />}
                        </Tabs>
                    </AppBar>
                </Box>
                <Paper elevation={3}>
                    <Box p={5}>
                        <Grid container spacing={5}>
                            <Grid item xs={12}>
                                <Box p={2} value={tabValue} index={PrivilegedTab} hidden={tabValue !== PrivilegedTab}>
                                    <Priv />
                                </Box>
                                <Box p={2} value={tabValue} index={StandardTab} hidden={tabValue !== StandardTab}>
                                    <Standard />
                                </Box>
                                <Box p={2} value={tabValue} index={ExternalTab} hidden={tabValue !== ExternalTab}>
                                    <External />
                                </Box>
                                <Box p={2} value={tabValue} index={AccessKeysTab} hidden={tabValue !== AccessKeysTab}>
                                    <Accesskeys />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};

export {
    AuthContainer as default,
    PrivilegedTab,
    StandardTab,
    ExternalTab,
    AccessKeysTab
};
